import { Close } from "@mui/icons-material";
import { IconButton, styled } from "@mui/material";
import { TableContext } from "components/Table2";
import CheckBox from "components/Table2/CheckBox";
import { useContext } from "react";

export default function Row({ row, index, isChild }: RowProps) {
  const table = useContext(TableContext);
  const { pagination, checkbox, bgColor } = table;
  let indexBegin = 0;
  if (pagination) indexBegin = (pagination.page - 1) * pagination.perPage;
  const tableBorder = table.tableBorder !== undefined ? table.tableBorder : true;
  const textColor = table.textColor?.body;
  const isSelected = checkbox?.items.includes(row[checkbox.key]);
  const cols = isChild ? table.childCols : table.cols;
  function Index({ index }: { index: number }) {
    return (
      <StyledTd
        fixRight
        first
        style={{ textAlign: "center", minWidth: "45px", right: table.withCheckBox && checkbox ? 53 : 0 }}
        {...{ bgColor, tableBorder, textColor, isChild }}
      >
        <div
          className={
            table.withBorder
              ? `border border-slate-300 rounded-md  h-10 flex justify-center items-center w-10`
              : ""
          }
        >
          <span>{indexBegin + index + 1}</span>
        </div>
      </StyledTd>
    );
  }

  return (
    <tr key={index} onClick={() => table.handleRowClick && table.handleRowClick(row)}>
      {table.withCheckBox && checkbox && (
        <StyledTd
          fixRight
          first
          style={{ textAlign: "center", minWidth: 53, width: 53, padding: 5 }}
          {...{ bgColor, tableBorder, textColor, isChild }}
        >
          <CheckBox
            active={isSelected}
            onChange={(checked) => {
              let s = checkbox.items;
              const key = checkbox.key || "id";
              if (s && !checked) s = s.filter((x) => x !== row[key]);
              if (s && checked) s.push(row[key]);
              checkbox.onChange && s && checkbox.onChange(s);
            }}
          />
        </StyledTd>
      )}
      {!isChild && <Index index={index} />}

      {cols &&
        cols.map((col, i, arr) => {
          const { Comp, fixLeft, fixRight, style, getValue, first } = col;
          const last = table.withoutMenu && i === arr.length - 1;
          let val = row && (row as any)[col.key];
          if (getValue) val = getValue(row);
          const o = col.options;

          if (o?.emptyOnNoVal && val === undefined) {
            return (
              <StyledTd
                key={i}
                {...{ bgColor, last, fixLeft, fixRight, tableBorder, textColor }}
                styles={style}
              >
                <div
                  className={`border-slate-300 h-10  rounded-md ${o?.classes}`}
                  style={{ border: table.withBorder && !o?.emptyOnNoValNoBorder ? "1px solid" : "" }}
                ></div>
              </StyledTd>
            );
          }

          return (
            <StyledTd
              key={i}
              first={isChild && i === 0}
              {...{ bgColor, last, style, fixLeft, fixRight, tableBorder, textColor, isChild }}
            >
              <div className="text-wrap">
                <Comp
                  key={col.key}
                  colKey={col.key}
                  row={row}
                  data={col.data}
                  val={val}
                  options={col.options}
                  onChange={table.onChange}
                  style={{ borderColor: "#94a3b8" }}
                  inputProps={col?.options?.inputProps}
                  withBorder={table.withBorder}
                  index={i}
                />
              </div>
            </StyledTd>
          );
        })}

      {!table.withoutMenu && (
        <StyledTd fixLeft last style={{ padding: 8 }} {...{ bgColor, tableBorder, textColor, isChild }}>
          <IconButton aria-label="delete" onClick={() => table.onDelete && table.onDelete(row)}>
            <Close className="text-base" />
          </IconButton>
        </StyledTd>
      )}
    </tr>
  );
}

const borderStyle = "1px solid rgba(100, 100, 100, 0.75)";
const StyledTd = styled("td")((props: StyledTdProps) => ({
  padding: 5,
  backgroundColor: props.isChild ? "#eceff1" : props.bgColor || "#ffffff",
  ...(props.tableBorder && { borderTop: borderStyle, borderLeft: borderStyle }),
  fontSize: 14,
  color: props.textColor || "#3D3D3D",
  ...(props.fixLeft && {
    textAlign: "center",
    width: "45px",
    position: "sticky",
    left: 0,
    top: 0,
    ...(props.last && props.tableBorder && { borderRight: borderStyle }),
  }),
  ...(props.fixRight && { position: "sticky", right: 0, top: 0, zIndex: 2 }),
  ...(props.last && { borderLeft: 0, ...(props.isChild && { borderRadius: "6px 0px 0px 6px" }) }),
  ...(props.first && { ...(props.isChild && { borderRadius: "0px 6px 6px 0px" }) }),
  ...props.styles,
}));
